<template>
  <div class="survey-container">
    <div v-if="surveyPage === 1 && !surveyCompleted">
      <activation-survey-first-page :questions="pageQuestions"/>
    </div>
    <div v-else-if="surveyPage === 2 && !surveyCompleted">
      <activation-survey-second-page :questions="pageQuestions"/>
    </div>
    <alert-page v-else :emoji="'🎉'"
                :title="'תודה!'"
                :showButton="false">
      <template v-slot:content>התשובות יעזרו לנו להמשיך ולשפר את השירות 💪</template>
    </alert-page>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';

import Segment from '../../../../../Segment';
import ActivationSurveyFirstPage from './ActivationSurveyFirstPage.vue';
import ActivationSurveySecondPage from './ActivationSurveySecondPage.vue';
import AlertPage from '../../../../../base-components/AlertPage.vue';

export default {
  name: 'ActivationSurvey',
  components: {
    ActivationSurveyFirstPage,
    ActivationSurveySecondPage,
    AlertPage,
  },
  created() {
    Segment.trackUserGot('ActivationSurveyEntered');
  },
  computed: {
    ...mapState('activationSurvey', ['questions', 'firstPageCompleted', 'surveyCompleted']),
    requiredAnswersAreEmpty() {
      const requiredAnswers = _.filter(this.questions, question => question.required === true);
      return _.some(requiredAnswers, question => question.answer === null);
    },
    surveyPage() {
      return this.firstPageCompleted ? 2 : 1;
    },
    pageQuestions() {
      return _.filter(this.questions, question => question.page === this.surveyPage);
    },
  },
  methods: {
    ...mapActions('activationSurvey', ['saveAnswers']),
    async saveSurveyAnswers() {
      Segment.trackUserInteraction('ActivationSurveyAnsweredClicked', {});
      await this.saveAnswers();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .survey-container {
    font-family: SimplerPro;
    text-align: right;
    color: $riseup_black;
    padding: 2px 23px 23px 23px;
  }
</style>
